import { isNoValueContact } from '../ProfileContactsWidget.utils'
import { ProfileContactsWidgetListCell } from '../ProfileContactsWidgetListCell'
import { ProfileContactsWidgetListCellNoValue } from '../ProfileContactsWidgetListCellNoValue'

function ProfileContactsWidgetList({
  api,
  canEdit,
  contacts,
  editingContactId,
  editingIsDirty,
  onClickEmail,
  onDirtyChange,
  onEdited,
  onEditRequest,
  onSuccess,
}) {
  return contacts.map(contact =>
    isNoValueContact(contact) && !contact.canEdit ? (
      <ProfileContactsWidgetListCellNoValue
        key={contact.id}
        typeConfig={contact.typeConfig}
      />
    ) : (
      <ProfileContactsWidgetListCell
        api={api}
        canEdit={canEdit}
        contact={contact}
        editingContactId={editingContactId}
        editingIsDirty={editingIsDirty}
        key={contact.id}
        onClickEmail={onClickEmail}
        onDirtyChange={onDirtyChange}
        onEdited={onEdited}
        onEditRequest={onEditRequest}
        onSuccess={onSuccess}
      />
    )
  )
}

export default ProfileContactsWidgetList
